import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconDeezerStyle0 = gravityIconIndividualCss;

const GravityIconDeezer = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '4a3e5790a8867caef0a427b10f77150a4b775f10', color: this.color, size: this.size }, h("svg", { key: '78bfd6ab6a09c6ff090558201b40c624a92a019f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'dde1e5f6d2b28ef6dcbc9fbb96902d6d768dc328', d: "M16.108 5.12H20v2.272h-3.892V5.121Zm0 3.164H20v2.271h-3.892V8.284ZM20 11.445h-3.892v2.271H20v-2.27ZM2 14.608h3.892v2.271H2v-2.27Zm8.594 0H6.702v2.271h3.892v-2.27Zm.812 0h3.892v2.271h-3.892v-2.27Zm8.594 0h-3.892v2.271H20v-2.27Zm-8.594-3.163h3.892v2.271h-3.892v-2.27Zm-.812 0H6.702v2.271h3.892v-2.27ZM6.702 8.284h3.892v2.271H6.702V8.284Z", fill: "currentColor" }))));
    }
};
GravityIconDeezer.style = GravityIconDeezerStyle0;

export { GravityIconDeezer as gravity_icon_deezer };

//# sourceMappingURL=gravity-icon-deezer.entry.js.map